<!--
 * @Author: your name
 * @Date: 2019-11-08 16:35:35
 * @LastEditTime: 2019-11-19 21:49:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\collectFolder\UCCollectItemList.vue
 -->
<!--  -->
<template>
  <div>
    <el-tree
      show-checkbox
      :data="collectItems.objects"
      node-key="id"
      empty-text="该分组下没有收藏内容哦"
      :props="defaultProps"
      :expand-on-click-node="false"
      @node-click="_nodeClickHandler"
      @check-change="_checkChangeHandler"

      
    >

    <span
        style="overflow-x: auto;width:100%;display:flex;align-items: center;"
        class="custom-tree-node"
        slot-scope="{ node, data }"
      >

      <div style="width:200px">
        
      
      <i v-if="data.type==='point'" class="i-point"></i>

      <i  v-if="data.type==='polyline'"  class="i-polyline"></i>

      <i  v-if="data.type==='polygon'"  class="i-polygon"></i>
      


        <!--鼠标移上去显示全称 -->
        <span style="font-weight: 700;font-size: 14px;" :title="node.label" >{{ node.label }}</span>


      </div>

      

        <el-button
          v-show="componentSetting.itemDeleteVisible"
          style="margin-left:30px;font-size:16px"
          type="text"
          size="small"
          icon="el-icon-delete"
          @click="_deleteCollectItemHandler(data)"
        ></el-button>

      </span>

    </el-tree>

  </div>
</template>

<script>
import {
  UserCollectItem,
  UserCollectItems,
  UserCollectItemFilter,
  UserCollectItemFilterResult
} from "../model/UserCollectJs.js";
import { ServiceUrlConfig } from "../../../config/ServiceUrlConfigJs";
import { UCCollectFolderEvents } from './UCCollectFolderJs';


export default {
  name: "UCCollectItemList",
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "name"
      },
      
      componentSetting: {
        itemDeleteVisible: true,
      },

      collectItems: new UserCollectItems(),

      curCollectItem: null,

      curCollectFolderId: null,

    };
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {
    init() {
      this.collectItems = new UserCollectItems();
      this.curCollectItem = null;

      this._initDataProvider();
    },

    on_nodeCheckedChange(callback)
    { 
      if(callback)
      { 
        this.$on(UCCollectFolderEvents.UCCollectItemList_event_nodeCheckdStatusChange,callback);
      }
    },

    off_nodeCheckedChange(callback)
    { 
      if(callback)
      { 
        this.$off(UCCollectFolderEvents.UCCollectItemList_event_nodeCheckdStatusChange,callback);
      }
    },

    off_deleteNode(callback){
      if(callback)
      { 
        this.$off(UCCollectFolderEvents.UCCollectItemList_event_deleteNode,callback);
      }
    },

    on_deleteNode(callback){
      if(callback)
      { 
        this.$on(UCCollectFolderEvents.UCCollectItemList_event_deleteNode,callback);
      }
    },



    /**
     * 添加收藏项
     */
    addCollectItem(item) {},
    
    _initDataProvider() {
      let self = this;

      let filter = new UserCollectItemFilter();
      filter.useFolderId = true;
      filter.folderId = this.curCollectFolderId;

      let selectUrl = ServiceUrlConfig.platform_collectitem_selectByFilter;
      UserCollectItems.selectByFilter(
        filter,
        selectUrl,
        function(response) {
          if (response) {
            let filterResult = UserCollectItemFilterResult.fromJson(response);
            if (filterResult && filterResult.filterCollectItems) {
              self.collectItems = filterResult.filterCollectItems;
            }
          }
        },
        function() {}
      );
    },

    _nodeClickHandler(data) {
      if (data == null) return;

      this.curCollectItem = data;
    },

    _checkChangeHandler(treeNodeItem, checked, indeterminate) {
      if (!treeNodeItem) return;

      treeNodeItem.checked = checked;


      this.$emit(UCCollectFolderEvents.UCCollectItemList_event_nodeCheckdStatusChange,treeNodeItem);
      
    },

    _deleteCollectItemHandler(treeNode) {
      if (!treeNode) return;

      this.curCollectItem = treeNode;

      let self = this;

      let treeNodeName = treeNode.name;

      //在删除前，需要进行提示；先调用服务接口，调用成功后，删除tableData数据源记录。
      this.$confirm("是否确认删除" + treeNodeName + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(function() {
          if (!treeNode) return;

          let curItemId = treeNode.id;
          let ids = new Array();
          ids.push(curItemId);

          let deleteMultiUrl =
            ServiceUrlConfig.platform_collectitem_deleteMulti;

          UserCollectItems.deleteMulti(
            ids,
            deleteMultiUrl,
            function(response) {
              if (response.code == "ok") {
                self.$message({
                  showClose: true,
                  type: "success",
                  message: "删除成功!"
                });

                self._deleteCurrentTreeNode();

                self.$emit(UCCollectFolderEvents.UCCollectItemList_event_deleteNode,treeNode);

              } else {
                self.$message({
                  showClose: true,
                  type: "info",
                  message: "删除失败!"
                });
              }
            },
            function() {
              self.$message({
                showClose: true,
                type: "error",
                message: "删除失败!"
              });
            }
          );
        })
        .catch(function() {
          self.$message({
            showClose: true,
            type: "info",
            message: "已取消删除"
          });
        });
    },

    _deleteCurrentTreeNode() {
      if (!this.curCollectItem) return;

      let delItemId = this.curCollectItem.id;

      let findIndex = this.collectItems.findIndexById(delItemId);
      if (findIndex != -1) {
        this.collectItems.objects.splice(findIndex, 1);
      }
    },



  }
};
</script>

<style lang="scss" scoped>

.i-point {
    vertical-align:bottom;
    background: url("../../../assets/onlineMap/icon.png");
    background-position: -41px -25px;
    width: 17px;
    height: 16px;
    display: inline-block;
}

.i-polyline {
    background: url("../../../assets/onlineMap/icon.png");
    background-position: -65px -26px;
    width: 17px;
    height: 16px;
    display: inline-block;
}

.i-polygon {
    background: url("../../../assets/onlineMap/icon.png");
    background-position: -91px -26px;
    width: 17px;
    height: 16px;
    display: inline-block;
}


</style>